// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".my-form[data-v-f2880080]{padding-top:10px}.my-form .yzm[data-v-f2880080]{display:flex;justify-content:space-between}.my-form .yzm .el-button[data-v-f2880080]{height:40px;width:120px;margin-left:20px}[data-v-f2880080] .el-form .el-form-item:nth-child(-n+2){margin-bottom:30px}[data-v-f2880080] .el-form .el-form-item:last-child{margin-top:0!important;margin-bottom:16px!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
